/**
 * Configuration SEO centralisée pour l'application
 */

export interface SEOMetadata {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
}

export const DEFAULT_SEO: SEOMetadata = {
  title: 'TournoisPadel - Trouvez vos partenaires de padel et organisez des tournois',
  description: 'Plateforme leader pour trouver vos partenaires de padel, rejoindre des clubs, participer à des tournois et des épreuves en France.',
  image: 'https://tournoispadel.fr/og-image.jpg',
  url: 'https://tournoispadel.fr',
  type: 'website',
};

export const PAGE_SEO: Record<string, SEOMetadata> = {
  home: {
    title: 'TournoisPadel - Trouvez vos partenaires de padel',
    description: 'Plateforme leader pour trouver vos partenaires de padel, rejoindre des clubs et participer à des tournois en France.',
    image: 'https://tournoispadel.fr/og-home.jpg',
  },
  tournois: {
    title: 'Tournois Padel - Tous les tournois en France | TournoisPadel',
    description: 'Découvrez et participez à tous les tournois de padel en France. Filtrez par date, lieu, niveau et catégorie.',
    image: 'https://tournoispadel.fr/og-tournois.jpg',
  },
  compte: {
    title: 'Mon Compte - TournoisPadel',
    description: 'Gérez votre profil, vos tournois, vos clubs et vos préférences sur TournoisPadel.',
    image: 'https://tournoispadel.fr/og-compte.jpg',
  },
  messages: {
    title: 'Messages - TournoisPadel',
    description: 'Communiquez avec d\'autres joueurs de padel et organisateurs de tournois.',
    image: 'https://tournoispadel.fr/og-messages.jpg',
  },
  partenaires: {
    title: 'Nos Partenaires - TournoisPadel',
    description: 'Découvrez les partenaires et sponsors de TournoisPadel, la plateforme leader du padel en France.',
    image: 'https://tournoispadel.fr/og-partenaires.jpg',
  },
};

// Schéma JSON-LD pour Google Rich Results
export const getJsonLdSchema = (metadata: SEOMetadata) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'TournoisPadel',
  description: metadata.description,
  url: metadata.url || DEFAULT_SEO.url,
  image: metadata.image || DEFAULT_SEO.image,
  inLanguage: 'fr-FR',
  creator: {
    '@type': 'Organization',
    name: 'TournoisPadel',
  },
});
